/* VPR theme behaviors. No framework. GSAP is loaded only by the hero section when needed. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('vpr-io');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('[data-reveal]').forEach(function (el, i) {
      var d = el.getAttribute('data-reveal');
      if (d && !isNaN(parseFloat(d))) el.style.transitionDelay = d + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Ingredient callout lines (label -> pouch, from live geometry) ---------- */
  function drawCallouts(stage) {
    var svg = stage.querySelector('[data-callout-svg]');
    var img = stage.querySelector('[data-callout-img]');
    var items = stage.querySelectorAll('[data-callout]');
    if (!svg || !img || !items.length) return;
    if (getComputedStyle(svg).display === 'none') { svg.innerHTML = ''; return; }

    var sb = stage.getBoundingClientRect();
    var ib = img.getBoundingClientRect();
    if (!sb.width || !ib.width) return;
    svg.setAttribute('viewBox', '0 0 ' + sb.width + ' ' + sb.height);
    var done = stage.classList.contains('is-drawn');
    var out = '';

    items.forEach(function (el) {
      var a = (el.getAttribute('data-anchor') || '0.5,0.8').split(',');
      var ax = ib.left - sb.left + parseFloat(a[0]) * ib.width;
      var ay = ib.top - sb.top + parseFloat(a[1]) * ib.height;

      var eb = el.getBoundingClientRect();
      var right = el.getAttribute('data-side') === 'r';
      var sx = (right ? eb.left : eb.right) - sb.left;
      var sy = eb.top - sb.top + eb.height / 2;

      /* the vertical run sits outside the can so a line never crosses the artwork */
      var step = (parseFloat(el.getAttribute('data-gutter')) || 0) * 14;
      var gx = right
        ? Math.min(sx - 18 - step, ib.left - sb.left + ib.width * 0.99)
        : Math.max(sx + 18 + step, ib.left - sb.left + ib.width * 0.01);

      var r = 10, d;
      if (Math.abs(sy - ay) < 16) {
        d = 'M' + sx + ' ' + sy + ' L' + ax + ' ' + ay;
      } else {
        var dx = gx > sx ? 1 : -1, dy = ay > sy ? 1 : -1, dx2 = ax > gx ? 1 : -1;
        d = 'M' + sx + ' ' + sy +
            ' L' + (gx - dx * r) + ' ' + sy +
            ' Q' + gx + ' ' + sy + ' ' + gx + ' ' + (sy + dy * r) +
            ' L' + gx + ' ' + (ay - dy * r) +
            ' Q' + gx + ' ' + ay + ' ' + (gx + dx2 * r) + ' ' + ay +
            ' L' + ax + ' ' + ay;
      }
      out += '<path d="' + d + '"></path><circle cx="' + ax + '" cy="' + ay + '" r="3.5"></circle>';
    });

    svg.innerHTML = out;
    svg.querySelectorAll('path').forEach(function (p) {
      var len = p.getTotalLength();
      p.style.strokeDasharray = len;
      p.style.strokeDashoffset = (reduce || done) ? 0 : len;
    });
    svg.querySelectorAll('circle').forEach(function (c) {
      c.style.opacity = (reduce || done) ? 1 : 0;
    });
  }

  function runCallouts(stage) {
    stage.classList.add('is-drawn');
    var svg = stage.querySelector('[data-callout-svg]');
    if (!svg) return;
    svg.querySelectorAll('path').forEach(function (p, i) {
      p.style.transition = 'stroke-dashoffset .85s cubic-bezier(.2,.7,.2,1) ' + (i * 110) + 'ms';
      p.style.strokeDashoffset = 0;
    });
    svg.querySelectorAll('circle').forEach(function (c, i) {
      c.style.transition = 'opacity .4s ease ' + (i * 110 + 480) + 'ms';
      c.style.opacity = 1;
    });
  }

  function initCallouts() {
    document.querySelectorAll('[data-callout-stage]').forEach(function (stage) {
      if (stage.dataset.calloutReady) { drawCallouts(stage); return; }
      stage.dataset.calloutReady = '1';

      var redraw = function () { drawCallouts(stage); };
      var imgEl = stage.querySelector('[data-callout-img] img');
      if (imgEl) {
        if (imgEl.complete) redraw();
        else imgEl.addEventListener('load', redraw);
      }
      redraw();
      if ('ResizeObserver' in window) new ResizeObserver(redraw).observe(stage);
      else window.addEventListener('resize', redraw);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(redraw);
      window.addEventListener('load', redraw);

      if (reduce || !('IntersectionObserver' in window)) { redraw(); runCallouts(stage); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          drawCallouts(stage);
          runCallouts(stage);
          io.disconnect();
        });
      }, { threshold: 0.25 });
      io.observe(stage);
    });
  }

  /* ---------- Offer / buy box ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v;
  }
  function initOffer() {
    document.querySelectorAll('[data-vpr-offer]').forEach(function (root) {
      if (root.dataset.offerReady) return;
      var data;
      try { data = JSON.parse(root.querySelector('[data-offer-json]').textContent); } catch (e) { return; }
      if (!data.variants || !data.variants.length) return;
      root.dataset.offerReady = '1';

      var cans = parseInt(root.getAttribute('data-cans') || '5', 10);
      var pouches = parseInt(root.getAttribute('data-pouches') || '20', 10);
      var byId = {};
      data.variants.forEach(function (v) { byId[v.id] = v; });

      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var saveEl = root.querySelector('[data-save]');
      var perCanEl = root.querySelector('[data-per-can]');
      var perPouchEl = root.querySelector('[data-per-pouch]');
      var renewalEl = root.querySelector('[data-renewal]');
      var errorEl = root.querySelector('[data-offer-error]');
      var img = root.querySelector('[data-offer-image]');
      var summaryEl = root.querySelector('[data-box-summary]');
      var hintEl = root.querySelector('[data-bulk-hint]');
      var meterEl = root.querySelector('[data-bulk-meter]');
      var atcBtn = root.querySelector('[data-offer-atc]');
      var atcText = root.querySelector('[data-atc-text]');
      var tiers = [].slice.call(root.querySelectorAll('[data-bulk]')).map(function (el) {
        return { el: el, min: parseInt(el.getAttribute('data-min'), 10) || 1, off: parseFloat(el.getAttribute('data-off')) || 0 };
      }).sort(function (a, b) { return a.min - b.min; });

      /* The subscription is pre-selected whenever the shop has a selling plan. */
      var state = { plan: data.plans && data.plans.length ? data.plans[0] : null, counts: {}, last: null };
      var startId = parseInt(root.getAttribute('data-default-variant'), 10);
      var startVariant = byId[startId] || data.variants.filter(function (v) { return v.available; })[0];
      if (startVariant) { state.counts[startVariant.id] = 1; state.last = startVariant; }

      function unitPrice(v) {
        if (!state.plan) return v.price;
        var alloc = (v.allocations || []).filter(function (a) { return a.plan === state.plan.id; })[0];
        return alloc ? alloc.price : v.price;
      }
      function totalPacks() {
        var n = 0;
        for (var k in state.counts) n += state.counts[k];
        return n;
      }
      function currentTier(packs) {
        var hit = null;
        tiers.forEach(function (t) { if (packs >= t.min) hit = t; });
        return hit;
      }
      function nextTier(packs) {
        var next = null;
        for (var i = 0; i < tiers.length; i++) {
          if (tiers[i].min > packs && tiers[i].off > 0) { next = tiers[i]; break; }
        }
        return next;
      }

      function render() {
        var packs = totalPacks();
        var tier = currentTier(packs);
        var off = tier ? tier.off : 0;

        /* Shopify floors the percentage discount per unit, so mirror it line by line. */
        var net = 0, listGross = 0;
        for (var id in state.counts) {
          var q = state.counts[id];
          if (!q) continue;
          var v = byId[id];
          var unit = unitPrice(v);
          net += (unit - Math.floor(unit * off / 100)) * q;
          listGross += v.price * q;
        }
        var compare = listGross > net ? listGross : 0;

        if (priceEl) priceEl.textContent = money(net);
        if (compareEl) { compareEl.textContent = compare > net ? money(compare) : ''; compareEl.hidden = !(compare > net); }
        if (saveEl) { var saved = compare > net ? compare - net : 0; saveEl.textContent = saved ? 'Save ' + money(saved) : ''; saveEl.hidden = !saved; }
        var totalCans = packs * cans;
        if (perCanEl) perCanEl.textContent = totalCans ? money(Math.round(net / totalCans)) : '—';
        if (perPouchEl) perPouchEl.textContent = totalCans ? money(Math.round(net / (totalCans * pouches))) : '—';

        tiers.forEach(function (t) {
          t.el.classList.toggle('is-reached', packs >= t.min);
          t.el.classList.toggle('is-active', !!tier && t.min === tier.min);
        });

        var nxt = nextTier(packs);
        if (hintEl) {
          if (!packs) hintEl.textContent = 'Add a flavor below to build your box.';
          else if (nxt) {
            var moreCans = (nxt.min - packs) * cans;
            hintEl.innerHTML = 'Add ' + moreCans + ' more can' + (moreCans === 1 ? '' : 's') + ' to <b>save ' + nxt.off + '%</b>.';
          } else if (off > 0) hintEl.innerHTML = 'Best value unlocked. <b>' + off + '% off</b> applied below.';
          else hintEl.textContent = '';
        }
        if (meterEl) {
          var target = nxt ? nxt.min : (tier ? tier.min : 1);
          meterEl.style.width = Math.min(100, Math.round((packs / target) * 100)) + '%';
        }
        if (summaryEl) summaryEl.textContent = totalCans ? totalCans + ' cans · ' + packs + (packs === 1 ? ' pack' : ' packs') : '';

        root.querySelectorAll('[data-mix]').forEach(function (row) {
          var id = row.getAttribute('data-variant');
          var q = state.counts[id] || 0;
          var out = row.querySelector('[data-count]');
          if (out) out.textContent = q;
          row.classList.toggle('is-picked', q > 0);
          var minus = row.querySelector('[data-step="-1"]');
          if (minus) minus.disabled = q === 0;
        });

        root.querySelectorAll('[data-plan]').forEach(function (b) {
          var id = b.getAttribute('data-plan');
          var on = (state.plan ? String(state.plan.id) : '') === id;
          b.classList.toggle('is-selected', on);
          var r = b.querySelector('input[type=radio]'); if (r) r.checked = on;
          var pv = b.querySelector('.vpr-offer__plan-price b');
          if (pv && state.last) {
            var pPlan = id ? data.plans.filter(function (x) { return String(x.id) === id; })[0] : null;
            var alloc = pPlan ? (state.last.allocations || []).filter(function (a) { return a.plan === pPlan.id; })[0] : null;
            pv.textContent = money(alloc ? alloc.price : state.last.price);
          }
        });

        if (img && state.last && state.last.image) { img.src = state.last.image; img.alt = state.last.title + ' VPR pouches'; }

        var label;
        if (!packs) label = root.getAttribute('data-atc-empty') || 'Pick at least one flavor';
        else label = (state.plan ? (root.getAttribute('data-atc-sub') || 'Subscribe and save') : (root.getAttribute('data-atc') || 'Add to cart')) + ' — ' + money(net);
        if (atcText) atcText.textContent = label;
        if (atcBtn) atcBtn.disabled = !packs;

        if (renewalEl) {
          if (state.plan && packs) {
            var recur = 0;
            for (var id2 in state.counts) { if (state.counts[id2]) recur += unitPrice(byId[id2]) * state.counts[id2]; }
            renewalEl.textContent = 'Recurring subscription. After this order you are charged ' + money(recur) +
              ' on each delivery until you cancel. Skip or cancel anytime, no fees.';
            renewalEl.hidden = false;
          } else { renewalEl.hidden = true; renewalEl.textContent = ''; }
        }

        var sPrice = root.querySelector('[data-vpr-sticky-price]');
        if (sPrice) sPrice.textContent = money(net);
        var sNote = root.querySelector('[data-vpr-sticky-note]');
        if (sNote) sNote.textContent = totalCans ? totalCans + ' cans · ' + packs + (packs === 1 ? ' pack' : ' packs') : 'Nothing picked yet';
        var sBtn = root.querySelector('[data-sticky-add]');
        if (sBtn) { sBtn.textContent = label; sBtn.disabled = !packs; }

        if (root.hasAttribute('data-sync-url') && state.last) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', state.last.id);
          history.replaceState(null, '', url);
        }
      }

      root.addEventListener('click', function (e) {
        var step = e.target.closest('[data-step]');
        if (step) {
          var row = step.closest('[data-mix]');
          var id = row.getAttribute('data-variant');
          var delta = parseInt(step.getAttribute('data-step'), 10);
          var next = Math.max(0, Math.min(20, (state.counts[id] || 0) + delta));
          state.counts[id] = next;
          if (delta > 0 && byId[id]) state.last = byId[id];
          if (errorEl) errorEl.hidden = true;
          render();
          return;
        }
        var p = e.target.closest('[data-plan]');
        if (p) {
          var pid = p.getAttribute('data-plan');
          state.plan = pid ? data.plans.filter(function (x) { return String(x.id) === pid; })[0] || null : null;
          render();
        }
      });

      /* Mix and match means several line items, so this posts the whole box in one
         call and swaps in the freshly rendered cart drawer that comes back with it. */
      function addToCart() {
        var items = [];
        for (var id in state.counts) {
          if (!state.counts[id]) continue;
          var line = { id: parseInt(id, 10), quantity: state.counts[id] };
          if (state.plan) line.selling_plan = state.plan.id;
          items.push(line);
        }
        if (!items.length) return;
        var drawer = document.querySelector('cart-drawer-component');
        var sectionEl = drawer && drawer.closest('[id^="shopify-section-"]');
        var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
        var body = { items: items };
        if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }

        if (atcBtn) { atcBtn.classList.add('is-busy'); atcBtn.disabled = true; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart.');
            var html = res.json.sections && sectionId ? res.json.sections[sectionId] : null;
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var freshDrawer = doc.querySelector('cart-drawer-component');
              var oldDrawer = document.querySelector('cart-drawer-component');
              if (freshDrawer && oldDrawer) oldDrawer.replaceWith(freshDrawer);
              var freshIcon = doc.querySelector('cart-icon');
              var oldIcon = document.querySelector('cart-icon');
              if (freshIcon && oldIcon) oldIcon.replaceWith(freshIcon);
            }
            var d = document.querySelector('cart-drawer-component');
            if (d && typeof d.open === 'function') d.open();
            else window.location.href = '/cart';
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message || 'Could not add to cart.'; errorEl.hidden = false; }
          })
          .then(function () {
            if (atcBtn) { atcBtn.classList.remove('is-busy'); atcBtn.disabled = totalPacks() === 0; }
          });
      }

      if (atcBtn) atcBtn.addEventListener('click', addToCart);
      var stickyBtn = root.querySelector('[data-sticky-add]');
      if (stickyBtn) stickyBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });

      render();
    });
  }

  /* ---------- Sticky buy bar ---------- */
  function initSticky() {
    document.querySelectorAll('[data-vpr-sticky]').forEach(function (bar) {
      if (bar.dataset.stickyReady) return;
      var root = bar.closest('[data-vpr-offer]');
      var atc = root && root.querySelector('[data-offer-atc]');
      if (!atc || !('IntersectionObserver' in window)) return;
      bar.dataset.stickyReady = '1';

      /* Show the bar once the real button has scrolled out of view, in either
         direction, so the price and the CTA stay reachable the whole page. */
      var io = new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        bar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
      }, { threshold: 0 });
      io.observe(atc);
    });
  }

  /* ---------- Launch offer countdown ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-vpr-offer][data-offer-ends]').forEach(function (root) {
      if (root.dataset.countdownReady) return;
      var wrap = root.querySelector('[data-offer-urgency]');
      var out = root.querySelector('[data-offer-countdown]');
      if (!wrap || !out) return;
      var end = new Date(root.getAttribute('data-offer-ends')).getTime();
      if (isNaN(end)) return;
      root.dataset.countdownReady = '1';

      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = end - Date.now();
        if (left <= 0) { wrap.hidden = true; clearInterval(timer); return; }
        var d = Math.floor(left / 86400000);
        var h = Math.floor(left / 3600000) % 24;
        var m = Math.floor(left / 60000) % 60;
        var s = Math.floor(left / 1000) % 60;
        out.textContent = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        wrap.hidden = false;
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Compare table rows stagger ---------- */
  function initCompare() {
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-compare-table]').forEach(function (t) {
      var rows = t.querySelectorAll('tbody tr');
      rows.forEach(function (r) { r.style.opacity = 0; r.style.transform = 'translateY(10px)'; r.style.transition = 'opacity .5s ease, transform .5s ease'; });
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        rows.forEach(function (r, i) { r.style.transitionDelay = (i * 70) + 'ms'; r.style.opacity = 1; r.style.transform = 'none'; });
        io.disconnect();
      }, { threshold: 0.2 });
      io.observe(t);
    });
  }

  function init() { initReveal(); initCallouts(); initOffer(); initSticky(); initCountdown(); initCompare(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
